import { cva } from 'class-variance-authority';

export const comboboxChipVariants = cva(
  'eye:body-s eye:flex eye:max-w-full eye:min-w-0 eye:items-center eye:wrap-break-word eye:whitespace-normal',
  {
    variants: {
      variant: {
        default:
          'eye:min-h-24 eye:gap-4 eye:rounded-md eye:border eye:border-grey-40 eye:bg-grey-20 eye:p-[2px] eye:px-12',
        /** For content that already carries its own chrome, such as a status tag. */
        bare: '',
      },
    },
    defaultVariants: {
      variant: 'default',
    },
  },
);
